import { AxiosInstance, AxiosResponse } from 'axios';
import { DropdownEntityValuesRequestDto, DropdownsValuesRequestDto, DropdownValuesResponseDto } from '@sweatpals/shared';

export class DropdownsValuesService {
	private readonly baseRoute = 'dropdowns-values';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async getDropdownsValues(
		query: DropdownsValuesRequestDto
	): Promise<AxiosResponse<DropdownValuesResponseDto[]>> {
		return this.httpClient.get<DropdownValuesResponseDto[]>(`${this.baseRoute}/`, {
			params: query,
		});
	}

	public async getDropdownEntityValues(
		entity: string,
		query?: DropdownEntityValuesRequestDto
	): Promise<AxiosResponse<DropdownValuesResponseDto>> {
		return this.httpClient.get<DropdownValuesResponseDto>(`${this.baseRoute}/${entity}`, {
			params: query,
		});
	}
}
